import CountOfTotal from '../CountOfTotal';
import React, { FC } from 'react';
import cx from 'classnames';
import './CountLabel.scss';

interface CountLabelProps {
  label: string;
  content: string;
  maxLength: number;
  vertical: boolean;
}

const CountLabel: FC<CountLabelProps> = (props) => {
  const { label, content, maxLength, vertical } = props;

  return (
    <div className={cx({ vertical })}>
      {label}
      <CountOfTotal content={content} maxCnt={maxLength} />
    </div>
  );
};

export default CountLabel;
